class FacetsController
{
    FacetsTitleHTML(itemList)
	{
        itemList.each(function()
		{
			const list 	    = $(this);
			const itemFacet = list.find('.facetwp-facet');
            const itemTitle = list.data('label');

            itemFacet.addClass('teste')
            itemFacet.prepend('<h3>'+itemTitle+'</h3>');
		});
	}    

    FacetsNivelEducacaoReset(listFacets)
    {
        const checkboxItens = listFacets.find('li.nivelensino').find('.facetwp-facet').find('.facetwp-checkbox');
        const urlWithoutParams = window.location.origin + window.location.pathname;
    
        // Função para obter os parâmetros da URL
        function getUrlParams() {
            const params = new URLSearchParams(window.location.search);
            return params;
        }
    
        // Verifica se o parâmetro _nivelensino está presente na URL e se tem valor
        const params = getUrlParams();
        let nivelensinoValues = params.get('_nivelensino') ? params.get('_nivelensino').split(',') : [];

        // this.nivelEducacao = params.get('_nivelensino') ? params.get('_nivelensino') : '';
    
        checkboxItens.each(function()
        {
            $(this).click(function()
            {
                const value = $(this).data('value');
    
                if (!nivelensinoValues.includes(value))
                    nivelensinoValues.push(value);
                else
                    nivelensinoValues = nivelensinoValues.filter(v => v !== value);
                    
                const newURL = urlWithoutParams + '?_nivelensino=' + nivelensinoValues.join(',');
    
                history.pushState(null, '', newURL);
                location.reload();
                return false;
            });
        });
    }

    FacetsFonteInformacao(listFacets)
    {
        const checkboxItens     = listFacets.find('li.tipoconteudo').find('.facetwp-facet').find('.facetwp-checkbox');
        const resetButton       = listFacets.find('li.filtroFacetReset').find('.facetwp-facet-reset').find('button');
        const urlWithoutParams  = window.location.origin + window.location.pathname;
    
        // Função para obter os parâmetros da URL
        function getUrlParams() {
            const params = new URLSearchParams(window.location.search);
            return params;
        }
    
        // Verifica se o parâmetro _nivelensino está presente na URL e se tem valor
        const params            = getUrlParams();
        let nivelensinoValues   = params.get('_nivelensino') ? params.get('_nivelensino').split(',') : [];
        let fonteInformacao     = params.get('_tipoconteudo') ? params.get('_tipoconteudo').split(',') : [];

        checkboxItens.each(function()
        {
            $(this).click(function()
            {
                const value = $(this).data('value');
    
                if (!fonteInformacao.includes(value))
                    fonteInformacao.push(value);
                else
                    fonteInformacao = fonteInformacao.filter(v => v !== value);

                const newURL = urlWithoutParams + '?_nivelensino=' + nivelensinoValues.join(',') + '&_tipoconteudo=' + fonteInformacao.join(',');
    
                history.pushState(null, '', newURL);
                location.reload();
                return false;
            });
        });
        
        if(resetButton && resetButton.length > 0)
        {
            resetButton.click(function()
            {
                console.log('click')
                const url = new URL(window.location.href);

                url.searchParams.delete('_tipoconteudo');
                url.searchParams.delete('_search_filtros');

                window.history.replaceState({}, document.title, url);

                window.location.href = url;

                return false;
            })
        }  
    }

    FacetsFiltroChip(ListChips)
    {
        const chips = ListChips.find('ul').find('li[data-facet="nivelensino"],li[data-facet="tipoconteudo"]');
        
        if(chips && chips.length > 0)
        {
            chips.find('span.facetwp-selection-value').each(function()
            {
                const param = '_'+$(this).parent('li').data('facet');

                $(this).click(function()
                {
                    const value = $(this).data('value');

                    const url = new URL(window.location.href);
                    const params = new URLSearchParams(url.search);
                    const values = params.get(param) ? decodeURIComponent(params.get(param)).split(',') : [];

                    const index = values.indexOf(value);

                    if (index > -1) {
                        values.splice(index, 1);
                    }

                    if (values.length > 0) {
                        params.set(param, values.join(','));
                    } else {
                        params.delete(param);
                    }

                    // Check if '_nivelensino' is empty and remove all parameters if true
                    if (param === '_nivelensino' && values.length === 0) {
                        params.forEach((_, key) => {
                            if (key !== '_nivelensino' && key !== '_search_filtros') {
                                params.delete(key);
                            }
                        });
                        params.delete('_search_filtros');
                    }

                    params.delete('_paged');
                    params.delete('_ordenacao');

                    // Build the final URL manually to prevent encoding the commas
                    let newUrl = url.origin + url.pathname + '?';
                    newUrl += decodeURIComponent(params.toString());

                    window.history.pushState({}, '', newUrl);

                    window.location.href = newUrl;

                    return false;
                });
            })
        }
    }

    FacetsFiltroSearchChip(ListChips)
    {
        const chips = ListChips.find('ul').find('li[data-facet="search_filtros"]');
        
        if(chips && chips.length > 0)
        {
            const chipItem = chips.find('span.facetwp-selection-value');

            if(chipItem && chipItem.length > 0)
            {
                chipItem.click(function()
                {
                    const url = new URL(window.location.href);

                    url.searchParams.delete('_search_filtros');

                    url.searchParams.delete('_paged');
                    url.searchParams.delete('_ordenacao');                  

                    window.history.replaceState({}, document.title, url);

                    window.location.href = url;

                    return false;
                })
            }            
        }
    }

    FacetsFiltroAutocomplete(autocomplete)
    {
        autocomplete.append('<input type="text" class="facetwp-autocomplete-gm5" value="" placeholder="Pesquisar..." autocomplete="off" minlength="3">');
        
        const input     = autocomplete.find('input.facetwp-autocomplete-gm5');
        const popup     = autocomplete.find('.fcomplete-wrap');
        const submit    = autocomplete.find('input.facetwp-autocomplete-update');

        popup.append('<div class="fcomplete-status-gm5"><span class="Typography SM txColor Cinza_900">Mínimo de 3 ou mais caracteres</span></div>')

        input.on('input', function()
        {
            if($(this).val().length < 3 && $(this).val().length >= 1)
                popup.css({'display':'block'});
            else if(!$(this).val().length == 0)
                popup.css({'display':'none'});
            else
                popup.css({'display':'none'});
        });

        input.on('keypress', function(event)
        {
            if (event.key === "Enter")
            {
                event.preventDefault();

                if($(this).val().length < 3)
                    popup.css({'display':'block'});
                else
                {
                    const value     = $(this).val();
                    const param     = '_search_filtros';
                    const url       = new URL(window.location.href);
                    const params    = new URLSearchParams(url.search);

                    let cleanValue = value.replace(/[.,"]/g, ' ');

                    if (params.has(param))
                        params.set(param, cleanValue);
                    else
                        params.append(param, cleanValue);

                    params.delete('_paged');
                    params.delete('_ordenacao');

                    url.search = params.toString();
                    window.history.pushState({}, '', url.toString());

                    window.location.href = url.toString();
                }

                return false;
            }
        });

        submit.click(function(event)
        {
            event.preventDefault();

            if(input.val().length < 3)
                popup.css({'display':'block'});
            else
            {
                const value     = input.val();
                const param     = '_search_filtros';
                const url       = new URL(window.location.href);
                const params    = new URLSearchParams(url.search);

                let cleanValue = value.replace(/[.,"]/g, ' ');

                if (params.has(param))
                    params.set(param, cleanValue);
                else
                    params.append(param, cleanValue);

                params.delete('_paged');
                params.delete('_ordenacao');

                url.search = params.toString();
                window.history.pushState({}, '', url.toString());

                window.location.href = url.toString();
            }

            return false;
        });
    }

    FacetsPaginacao(paginacao)
    {
        paginacao.find('a.facetwp-page').each(function()
        {
            const thisButton = $(this);

            thisButton.click(function(e)
            {
                if(!thisButton.hasClass('active'))
                {
                    const param     = '_paged';
                    const url       = new URL(window.location.href);
                    const params    = new URLSearchParams(url.search);

                    if (params.has(param))
                        params.set(param, thisButton.data('page'));
                    else
                        params.append(param, thisButton.data('page'));

                    url.search = params.toString();
                    window.history.pushState({}, '', url.toString());
    
                    window.location.href = url.toString();
                }
                
                return false;
            });            
        });
    }

    FacetsOrdenacao(ordenacao)
    {
        ordenacao.find('select').on('change',function()
        {
            const value = $(this).val();
            const param = '_ordenacao';
            const url       = new URL(window.location.href);
            const params    = new URLSearchParams(url.search);

            params.delete('_paged');

            if(value)
                if (params.has(param))
                    params.set(param, value);
                else
                    params.append(param, value);
            else
                params.delete('_ordenacao');

            url.search = params.toString();
            window.history.pushState({}, '', url.toString());

            window.location.href = url.toString();

            return false;
        })
    }

    FacetsModalMobile(parent)
    {
        const aside = parent;
        const buttonFiltrar = aside.find('button.openFilterFacetsMobile');

        if(buttonFiltrar.length > 0)
        {
            const modal = aside.find('.Filtros')
            const buttonClose = modal.find('.wrapFiltros').find('.CabecalhoModal').find('button.closeFilterFacetsMobile');

            buttonFiltrar.click(function()
            {
                console.log()
                modal.addClass('opened');
            });

            buttonClose.click(function()
            {
                modal.removeClass('opened');
            })
        }
    }

    init(options)
	{
		const self = this;

        const parent            = $("#CCListaConteudoEducaRacista");
        const listFacetChips    = parent.find('.FacetsChips');
        const listFacets        = parent.find('.ListaFiltroFacets');
        const listFacetsList    = listFacets.find('li.filtroFacet');

        const AutoComplete      = parent.find('.facetwp-facet-search_filtros');
        
        const OrderFacet        = parent.find('.OrderFacets').find('.facetwp-facet-ordenacao');

        const paginacao         = parent.find('.facetwp-pager');

        if (parent.length > 0)
        {
            if(listFacetsList.length > 0)
                self.FacetsTitleHTML(listFacetsList);

            if(listFacets.length > 0)
            {
                self.FacetsNivelEducacaoReset(listFacets);
                self.FacetsFonteInformacao(listFacets);
            }

            if(listFacetChips.length > 0)
            {
                self.FacetsFiltroChip(listFacetChips);
                self.FacetsFiltroSearchChip(listFacetChips);
            }

            if(OrderFacet.length > 0)
                self.FacetsOrdenacao(OrderFacet);

            if($('.AsideFiltrosFacets').length > 0)
                self.FacetsModalMobile($('.AsideFiltrosFacets'));

            if(AutoComplete.length > 0)
                self.FacetsFiltroAutocomplete(AutoComplete);

            if(paginacao.length > 0)
                self.FacetsPaginacao(paginacao);

            $(window).resize(function()
            {
            });
        }

        document.addEventListener('facetwp-loaded', function()
        {
            self.FacetsTitleHTML(listFacetsList);
            self.FacetsNivelEducacaoReset(listFacets);
            self.FacetsFonteInformacao(listFacets);
            self.FacetsFiltroAutocomplete(AutoComplete);
            self.FacetsPaginacao(paginacao);
        });
	}
}

export default FacetsController;